/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Icon, message, Pagination, Radio} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import cookie from 'react-cookies'
import CRM from '../BaseComponent/CRM'
import {accounting} from 'accounting'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {voip} from '../Reports/call/voip'
import Loader from '../loaders/loader'

class AddCrm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      orderDate: null,
      orderDateTo: null,
      deliveryDate: null,
      deliveryDateTo: null,
      mediaList: [],
      categoryList: [],
      subjectList: [],
      definitionList: [],
      priorityList: [],
      searchByCustomerCode: false,
      searchByInvoiceNumber: false,
      current: 1,
      pageSize: 10,
      searchedCustomer: [],
      partSearchedCustomer: [],
      searchedCustomerByInvoice: [],
      partSearchedCustomerByInvoice: [],
      selectedRadio: '',
      showTable: false,
      showTableByInvoice: false,
      selectedCustomerName: '',
      selectedCustomerLastName: '',
      selectedCustomerCode: '',
      selectedCustomerMobile: '',
      readOnlyField: false,
      customerId: '',
      invoiceId: '',
      invoiceNum: '',
      test: '',
      modalInvoiceItem: false,
      invoiceItems: [],
      pageNumberDetailInvoice: 1,
      lengthProducts: '',
      selectedCode: '',
      deliDate: '',
      registerDate: '',
      showFactor: false,
      smsModal: false,
      customerCode: '',
      queryCategoryId: '',
      querySubjectId: '',
      queryPriorityId: '',
      statusList: []
    }
  }

  loadCustomerByQuery = (customerCode) => {
    http
      .get(`${CRM.CRM_CONTACT_SEARCH_BY_CUSTOMER_INFO}?customerCode=${customerCode}&export=true`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            selectedCustomerName: response.data.object.result[0].firstName,
            selectedCustomerLastName: response.data.object.result[0].lastName,
            selectedCustomerCode: response.data.object.result[0].code,
            selectedCustomerMobile: response.data.object.result[0].phoneNumber.replace(/\+98/g, '0'),
            searchByCustomerCode: false,
            customerId: response.data.object.result[0].id,
            readOnlyField: true,
            selectedCode: response.data.object.result[0].code,
            showFactor: false
          })
        } else {
          message.error(response.data.error)
        }
      })
  }

  loadInvoiceByQuery = (invoiceNum) => {
    http.get(`${CRM.CRM_CONTACT_SEARCH_BY_CUSTOMER_INVOICE}?invoiceNum=${invoiceNum}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          selectedCustomerName: response.data.object.result[0].firstName,
          selectedCustomerLastName: response.data.object.result[0].lastName,
          selectedCustomerCode: response.data.object.result[0].code,
          selectedCustomerMobile: response.data.object.result[0].phoneNumber.replace(/\+98/g, '0'),
          searchByInvoiceNumber: false,
          customerId: response.data.object.result[0].userId,
          invoiceId: response.data.object.result[0].invoiceId,
          invoiceNum: response.data.object.result[0].invoiceNum,
          deliDate: response.data.object.result[0].date,
          registerDate: response.data.object.result[0].regDate,
          readOnlyField: true,
          selectedCode: response.data.object.result[0].code,
          showFactor: true,
          fromInvoice: true
        })
      } else {
        message.error(response.data.error)
      }
    })
  }

  componentDidMount() {
    http.get(`crm/contact/status/list`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          statusList: response.data.object
        })
      } else {
        this.setState({
          statusList: []
        })
      }
    })

    var urlParams = new URLSearchParams(window.location.search)
    var customerCode = urlParams.get('customerCode') === null ? '' : urlParams.get('customerCode')
    var invoiceNum = urlParams.get('invoiceNum') === null ? '' : urlParams.get('invoiceNum')
    if (customerCode !== '') {
      this.setState({
        customerCode
      })
      this.loadCustomerByQuery(customerCode)
    }
    if (invoiceNum !== '') {
      this.loadInvoiceByQuery(invoiceNum)
    }

    if (!cookie.load('accessToken')) {
      window.location.assign('./')
    }

    sessionStorage.setItem('customerCode', '')

    http.get(`${CRM.CRM_CONTACT_MEDIA_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          mediaList: response.data.object
        })
      } else {
        this.setState({
          mediaList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_CATEGORY_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response.data))
      if (response.data.error == null) {
        this.setState(
          {
            categoryList: response.data.object
          },
          () => {
            let fromRfml = urlParams.get('fromRfml') === null ? '' : urlParams.get('fromRfml')

            if (fromRfml === 'true') {
              // queryCategoryId
              let findCat = this.state.categoryList.find((item) => item.contactCategoryId === 8)
              if (findCat) {
                this.setState({
                  queryCategoryId: findCat.contactCategoryId
                })
              }
            }
          }
        )
      } else {
        this.setState({
          categoryList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState(
          {
            subjectList: response.data.object
          },
          () => {
            let fromRfml = urlParams.get('fromRfml') === null ? '' : urlParams.get('fromRfml')

            if (fromRfml === 'true') {
              // queryCategoryId
              let findSubject = this.state.subjectList.find((item) => item.contactSubjectId === 16)
              if (findSubject) {
                this.setState(
                  {
                    querySubjectId: findSubject.contactSubjectId
                  },
                  () => {
                    http
                      .get(`${CRM.CRM_CONTACT_DEFINITION_LIST}?contactSubjectId=${this.state.querySubjectId}`, {})
                      .then((response) => {
                        if (response.data.error == null) {
                          this.setState({
                            definitionList: response.data.object
                          })
                        } else {
                          this.setState({
                            definitionList: []
                          })
                        }
                      })
                  }
                )
              }
            }
          }
        )
      } else {
        this.setState({
          subjectList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          definitionList: response.data.object
        })
      } else {
        this.setState({
          definitionList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_PRIORIRT_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response))
      if (response.data.error == null) {
        this.setState(
          {
            priorityList: response.data.object
          },
          () => {
            // queryPriorityId
            let fromRfml = urlParams.get('fromRfml') === null ? '' : urlParams.get('fromRfml')

            if (fromRfml === 'true') {
              // queryCategoryId
              let findPr = this.state.priorityList.find((item) => item.contactPriorityId === 3)
              if (findPr) {
                this.setState({
                  queryPriorityId: findPr.contactPriorityId
                })
              }
              document.getElementById('comment').focus()
            }
          }
        )
      } else {
        this.setState({
          priorityList: []
        })
      }
    })
  }

  changeCategory(e) {
    let value = e.target.value

    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?contactCategoryId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          subjectList: response.data.object
        })
      } else {
        this.setState({
          subjectList: []
        })
      }
    })
  }

  changeSubject(e) {
    let value = e.target.value

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}?contactSubjectId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          definitionList: response.data.object
        })
      } else {
        this.setState({
          definitionList: []
        })
      }
    })
  }

  handleOrderDate = (date) => {
    this.setState({orderDate: date})
  }

  handleOrderDateTo = (date) => {
    this.setState({orderDateTo: date})
  }

  handleDeliveryDate = (date) => {
    this.setState({deliveryDate: date})
  }

  handleDeliveryDateTo = (date) => {
    this.setState({deliveryDateTo: date})
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  orderDateEl(props) {
    return <input className="form-control" {...props} />
  }

  orderDateElTo(props) {
    return <input className="form-control" {...props} />
  }

  deliveryDateEl(props) {
    return <input className="form-control" {...props} />
  }

  deliveryDateElTo(props) {
    return <input className="form-control" {...props} />
  }

  openCodeForm() {
    this.setState({
      searchByCustomerCode: !this.state.searchByCustomerCode
    })
  }

  toggleByCode = () => {
    this.setState({
      searchByCustomerCode: !this.state.searchByCustomerCode
    })
  }

  searchByCode() {
    var CustomerCode = document.getElementById('CustomerCode').value.trim()
    var CustomerMobile = document.getElementById('CustomerMobile').value.trim()
    var nationalId = document.getElementById('nationalId').value.trim()
    var CustomerFirstName = document.getElementById('CustomerFirstName').value.trim()
    var CustomerLastName = document.getElementById('CustomerLastName').value.trim()
    if (
      nationalId == '' &&
      CustomerCode == '' &&
      CustomerMobile == '' &&
      CustomerFirstName == '' &&
      CustomerLastName == ''
    ) {
      message.error('حداقل یک فیلد وارد شود')
    } else {
      http
        .get(
          `${
            CRM.CRM_CONTACT_SEARCH_BY_CUSTOMER_INFO
          }?nationalId=${nationalId}&customerCode=${CustomerCode}&mobile=${CustomerMobile}&firstname=${CustomerFirstName}&lastname=${CustomerLastName}&export=true`,
          {}
        )
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null) {
            this.setState({
              selectedRadio: '',
              searchedCustomer: response.data.object.result,
              partSearchedCustomer: response.data.object.result.slice(0, 10),
              lengthSearchByCode: response.data.object.countAll,
              showTable: true
            })
          } else {
            this.setState({
              searchedCustomer: [],
              partSearchedCustomer: [],
              showTable: false
            })
          }
        })
    }
  }

  onChangePage(pageNumber) {
    // alert(pageNumber)
    this.setState({
      current: pageNumber,
      partSearchedCustomer: this.state.searchedCustomer.slice((pageNumber - 1) * 10, pageNumber * 10)
    })
  }

  onChangePageByInvoice(pageNumber) {
    // alert(pageNumber)
    this.setState({
      current: pageNumber,
      partSearchedCustomerByInvoice: this.state.searchedCustomerByInvoice.slice((pageNumber - 1) * 10, pageNumber * 10)
    })
  }

  cancelByCode = () => {
    this.setState({
      searchByCustomerCode: !this.state.searchByCustomerCode,
      searchedCustomer: [],
      partSearchedCustomer: [],
      length: 0,
      showTable: false
    })
    sessionStorage.setItem('customerCode', '')
  }

  openFactorForm() {
    this.setState({
      searchByInvoiceNumber: !this.state.searchByInvoiceNumber
    })
  }

  toggleByInvoiceNum = () => {
    this.setState({
      searchByInvoiceNumber: true
    })
  }

  cancelByInvoiceNum = () => {
    this.setState({
      searchByInvoiceNumber: !this.state.searchByInvoiceNumber
    })
  }

  searchByInvoiceNumCustomer = () => {
    var input_CustomerCode = document.getElementById('customerCodeByInvoice').value.trim()
    var input_CustomerInvoiceId = document.getElementById('invoiceId').value.trim()
    var input_CustomerInvoiceNum = document.getElementById('invoiceNum').value.trim()
    var registerDate = this.convertDigit(document.getElementById('registerDate').value)
    var registerDateTo = this.convertDigit(document.getElementById('registerDateTo').value)
    var deliveryDate = this.convertDigit(document.getElementById('deliveryDate').value)
    var deliveryDateTo = this.convertDigit(document.getElementById('deliveryDateTo').value)
    if (input_CustomerInvoiceId == '' && input_CustomerInvoiceNum == '' && input_CustomerCode == '') {
      message.error('حداقل فیلتر شناسه فاکتور یا شماره فاکتور یا کد مشتری وارد شود')
    } else {
      this.setState({
        loading: true
      })
      http
        .get(
          `${CRM.CRM_CONTACT_SEARCH_BY_CUSTOMER_INVOICE}?deliveryDateMin=${
            deliveryDate == '' ? '' : this.epochFrom(deliveryDate)
          }&deliveryDateMax=${deliveryDateTo == '' ? '' : this.epochTo(deliveryDateTo)}&registerDateMin=${
            registerDate == '' ? '' : this.epochFrom(registerDate)
          }&registerDateMax=${
            registerDateTo == '' ? '' : this.epochTo(registerDateTo)
          }&customerCode=${input_CustomerCode}&invoiceId=${input_CustomerInvoiceId}&invoiceNum=${input_CustomerInvoiceNum}&export=true&sortBy=regDate_desc`,
          {}
        )
        .then((response) => {
          // alert(JSON.stringify(response.data))

          this.setState({
            loading: false
          })
          if (response.data.error == null) {
            this.setState({
              selectedRadio: '',
              searchedCustomerByInvoice: response.data.object.result,
              partSearchedCustomerByInvoice: response.data.object.result.slice(0, 10),
              length: response.data.object.countAll,
              showTableByInvoice: true,
              current: 1,
              pageSize: 10
            })
          } else {
            this.setState({
              searchedCustomerByInvoice: [],
              partSearchedCustomerByInvoice: [],
              showTableByInvoice: false
            })
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }

  newCustomer = () => {
    this.setState({
      readOnlyField: false,
      selectedCustomerName: '',
      selectedCustomerLastName: '',
      selectedCustomerCode: '',
      selectedCustomerMobile: '',
      selectedCode: '',
      showFactor: false,
      partSearchedCustomer: [],
      showTable: false,
      partSearchedCustomerByInvoice: [],
      showTableByInvoice: false,
      customerCode: ''
    })
    sessionStorage.setItem('customerCode', '')
  }

  changeField(e) {
    let target = e.target
    let value = target.value
    let name = target.name
    this.setState({
      [name]: value
    })
  }

  addComment() {
    var media = document.getElementById('media').value
    var category = document.getElementById('category').value
    var subject = document.getElementById('subject').value
    var definition = document.getElementById('definition').value
    var gender = document.getElementById('gender').value
    var priority = document.getElementById('priority').value
    var comment = document.getElementById('comment').value.trim()
    var response = document.getElementById('response').value.trim()
    var action = document.getElementById('action').value.trim()
    var {
      selectedCustomerName,
      selectedCustomerMobile,
      selectedCustomerLastName,
      selectedCustomerCode,
      customerId,
      invoiceNum,
      invoiceId
    } = this.state
    var statusId = document.getElementById('statusId').value

    var errorForm = false
    var mediaError = false
    var catError = false
    var subjectError = false
    var defError = false
    var priorityError = false
    var commentError = false
    var nameError = false
    var familyError = false
    var mobileError = false
    if (media == '') {
      errorForm = true
      mediaError = true
      message.error('رسانه تماس را مشخص کنید')
    } else {
      if (!mediaError) {
        this.setState({
          test: ''
        })
      }
    }
    if (category == '') {
      catError = true
      errorForm = true
      message.error('خانواده تماس را مشخص کنید')
    } else {
      if (!catError) {
        this.setState({
          test: ''
        })
      }
    }
    if (subject == '') {
      subjectError = true
      errorForm = true
      message.error('موضوع تماس را مشخص کنید')
    } else {
      if (!subjectError) {
        this.setState({
          test: ''
        })
      }
    }
    if (definition == '') {
      defError = true
      errorForm = true
      message.error('جزییات تماس مشخص شود')
    } else {
      if (!defError) {
        this.setState({
          test: ''
        })
      }
    }
    if (priority == '') {
      priorityError = true
      errorForm = true
      message.error('اولویت مشخص شود')
    } else {
      if (!priorityError) {
        this.setState({
          test: ''
        })
      }
    }
    // if(selectedCustomerName=='' || selectedCustomerMobile=='' || selectedCustomerLastName==''){
    //     nameError=true;
    //     errorForm=true;
    //     message.error('لطفا مشخصات شخصی کاربر کامل وارد شود')
    // }
    // else{
    //     if(!nameError){
    //         this.setState({
    //             test:''
    //         })
    //     }
    // }
    if (comment == '') {
      commentError = true
      errorForm = true
      message.error('نظر وارد شود')
    } else {
      if (!commentError) {
        this.setState({
          test: ''
        })
      }
    }
    if (!errorForm) {
      let data = {
        contactMediaId: media,
        contactCategoryId: category,
        contactSubjectId: subject,
        contactDefinitionId: definition,
        contactStatusId: statusId,
        contactPriorityId: priority,
        mobile: selectedCustomerMobile.trim().replace(/\+98/g, '0'),
        firstname: !selectedCustomerName ? 'کاربر' : selectedCustomerName,
        lastname: !selectedCustomerLastName ? 'ناشناس' : selectedCustomerLastName,
        customerId: customerId,
        customerCode: selectedCustomerCode,
        invoiceId: invoiceId,
        invoiceNum: invoiceNum,
        contactComment: comment,
        gender: gender,
        contactResponse: response,
        contactAction: action
      }
      this.setState({
        loading: true
      })

      http
        .post(`${CRM.CRM_CONTACT_MASTER_DETAIL_ADD}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          this.setState({
            loading: false
          })
          if (response.data.error == null) {
            message.success('نظر مشتری با موفقیت ثبت شد.لطفا صبر کنید', 2000)
            setTimeout(() => {
              window.location.assign('/CRM/add')
            }, 2000)
          } else {
            message.error(response.data.description)
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  showInvoiceItems = (invoiceId) => {
    sessionStorage.setItem('invoiceId', invoiceId)
    http
      .get(`${CRM.CRM_CONTACT_INVOICE_ITEMS_LIST}?invoiceId=${invoiceId}&pageSize=10&pageNumber=1`, {})
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            modalInvoiceItem: !this.state.modalInvoiceItem,
            searchByInvoiceNumber: !this.state.searchByInvoiceNumber,
            invoiceItems: response.data.object.result,
            lengthProducts: response.data.object.result.length
          })
        } else {
          message.error(response.data.description)
        }
      })
  }

  onChangePaginationDetailsInvoice(pageNumber) {
    this.setState({
      pageNumber: pageNumber
    })
    let invoiceId = sessionStorage.getItem('invoiceId')

    http
      .get(
        `${CRM.CRM_CONTACT_INVOICE_ITEMS_LIST}?input_invoiceId=${invoiceId}&pageSize=10&pageNumber=${pageNumber}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            modalInvoiceItem: !this.state.modalInvoiceItem,
            searchByInvoiceNumber: !this.state.searchByInvoiceNumber,
            invoiceItems: response.data.object.result,
            lengthProducts: response.data.object.result.length
          })
        } else {
          message.error(response.data.description)
        }
      })
  }

  invoiceItems = () => {
    this.setState({
      modalInvoiceItem: !this.state.modalInvoiceItem,
      searchByInvoiceNumber: !this.state.searchByInvoiceNumber
    })
  }

  closeDetailsItems = () => {
    this.setState({
      modalInvoiceItem: !this.state.modalInvoiceItem,
      searchByInvoiceNumber: !this.state.searchByInvoiceNumber
    })
  }

  double = (rowId) => {
    // alert(rowId)

    this.setState({
      selectedCustomerName: this.state.searchedCustomer[rowId - 1].firstName,
      selectedCustomerLastName: this.state.searchedCustomer[rowId - 1].lastName,
      selectedCustomerCode: this.state.searchedCustomer[rowId - 1].code,
      selectedCustomerMobile: this.state.searchedCustomer[rowId - 1].phoneNumber.replace(/\+98/g, '0'),
      searchByCustomerCode: !this.state.searchByCustomerCode,
      customerId: this.state.searchedCustomer[rowId - 1].id,
      readOnlyField: true,
      selectedCode: this.state.searchedCustomer[rowId - 1].code,
      showFactor: false
    })
    sessionStorage.setItem('customerCode', this.state.searchedCustomer[rowId - 1].code)
  }

  selectFromCode = (rowId) => {
    this.setState({
      selectedCustomerName: this.state.searchedCustomer[rowId - 1].firstName,
      selectedCustomerLastName: this.state.searchedCustomer[rowId - 1].lastName,
      selectedCustomerCode: this.state.searchedCustomer[rowId - 1].code,
      selectedCustomerMobile: this.state.searchedCustomer[rowId - 1].phoneNumber.replace(/\+98/g, '0'),
      searchByCustomerCode: !this.state.searchByCustomerCode,
      customerId: this.state.searchedCustomer[rowId - 1].id,
      readOnlyField: true,
      selectedCode: this.state.searchedCustomer[rowId - 1].code,
      showFactor: false
    })
    sessionStorage.setItem('customerCode', this.state.searchedCustomer[rowId - 1].code)
  }

  dobuleByInovice = (rowId) => {
    this.setState({
      selectedCustomerName: this.state.searchedCustomerByInvoice[rowId - 1].firstName,
      selectedCustomerLastName: this.state.searchedCustomerByInvoice[rowId - 1].lastName,
      selectedCustomerCode: this.state.searchedCustomerByInvoice[rowId - 1].code,
      selectedCustomerMobile: this.state.searchedCustomerByInvoice[rowId - 1].phoneNumber.replace(/\+98/g, '0'),
      searchByInvoiceNumber: !this.state.searchedCustomerByInvoice,
      customerId: this.state.searchedCustomerByInvoice[rowId - 1].userId,
      invoiceId: this.state.searchedCustomerByInvoice[rowId - 1].invoiceId,
      invoiceNum: this.state.searchedCustomerByInvoice[rowId - 1].invoiceNum,
      deliDate: this.state.searchedCustomerByInvoice[rowId - 1].date,
      registerDate: this.state.searchedCustomerByInvoice[rowId - 1].regDate,
      readOnlyField: true,
      selectedCode: this.state.searchedCustomerByInvoice[rowId - 1].code,
      showFactor: true,
      fromInvoice: true
    })
  }

  selectedByInvoice = (rowId) => {
    this.setState({
      selectedCustomerName: this.state.searchedCustomerByInvoice[rowId - 1].firstName,
      selectedCustomerLastName: this.state.searchedCustomerByInvoice[rowId - 1].lastName,
      selectedCustomerCode: this.state.searchedCustomerByInvoice[rowId - 1].code,
      selectedCustomerMobile: this.state.searchedCustomerByInvoice[rowId - 1].phoneNumber.replace(/\+98/g, '0'),
      searchByInvoiceNumber: !this.state.searchedCustomerByInvoice,
      customerId: this.state.searchedCustomerByInvoice[rowId - 1].userId,
      invoiceId: this.state.searchedCustomerByInvoice[rowId - 1].invoiceId,
      invoiceNum: this.state.searchedCustomerByInvoice[rowId - 1].invoiceNum,
      deliDate: this.state.searchedCustomerByInvoice[rowId - 1].date,
      registerDate: this.state.searchedCustomerByInvoice[rowId - 1].regDate,
      readOnlyField: true,
      selectedCode: this.state.searchedCustomerByInvoice[rowId - 1].code,
      showFactor: true,
      fromInvoice: true
    })
  }

  openSmsModalToCustomer = (smsData) => {
    this.setState({
      smsData,
      smsModal: true,
      titleSms: 'ارسال پیام به مشتری'
    })
  }

  openSmsModalToRecipient = (smsData) => {
    this.setState({
      smsData,
      smsModal: true,
      titleSms: 'ارسال پیام به تحویل گیرنده'
    })
  }

  sendSmsToCustomer = () => {
    let newSmsData = this.state.smsData
    let contents = document.getElementById('contents').value.trim()
    if (contents === '') {
      message.error('متن پیام وارد شود ')
    } else {
      if (newSmsData.customerCode) {
        newSmsData.contents = contents
        http.post(`${CRM.CRM_CONTACT_SMS_SEND_CUSTOMER}`, newSmsData, {}).then((response) => {
          if (response.data.error === null) {
            message.success('پیام با موفقیت ارسال شد')
            this.setState({
              smsModal: false
            })
          }
        })
      } else {
        newSmsData.contents = contents
        http.post(`${CRM.CRM_CONTACT_SMS_SEND_RECIPIENT}`, newSmsData, {}).then((response) => {
          if (response.data.error === null) {
            message.success('پیام با موفقیت ارسال شد')
            this.setState({
              smsModal: false
            })
          }
        })
      }
    }
  }

  callToCustomer = (mobile, buyerName) => {
    if (mobile === '') {
      message.error('شماره موبایل مورد نظر وجود ندارد')
    } else {
      this.setState({
        showMobileCallModal: true
      })
      let internalPhone = '725'
      voip(mobile, buyerName)
        .then((res) => {
          if (res) {
            message.success('تماس برقرار شد لطفا منتظر پاسخ بمانید')
          } else {
            console.log('error')
            this.setState({
              showMobileCallModal: false
            })
          }
        })
        .catch((err) => {
          message.error(err)
          this.setState({
            showMobileCallModal: false
          })
        })
    }
  }

  render() {
    let customerCode = sessionStorage.getItem('customerCode')
    let pageNumber = this.state.current
    let {deliveryDate, orderDate, orderDateTo, deliveryDateTo} = this.state
    return (
      <div className="rtl">
        <Loader show={this.state.loading} />
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>ارتباط با مشتری</li>
          </ul>
          <div className="basketFilterComponent" style={{marginTop: '10px'}}>
            <div className="filterInputs">
              <div className="formComponent">
                <label>رسانه تماس : </label>
                <select className="form-control" id="media">
                  <option value="">------</option>

                  {this.state.mediaList.map((media, index) => (
                    <option selected={media.contactMediaId == '1' ? true : false} value={media.contactMediaId}>
                      {media.contactMediaName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="formComponent">
                <label>خانواده تماس : </label>
                <select className="form-control" id="category" onChange={this.changeCategory.bind(this)}>
                  <option value="">------</option>
                  {this.state.categoryList.map((category, index) => (
                    <option
                      selected={category.contactCategoryId === this.state.queryCategoryId ? true : false}
                      value={category.contactCategoryId}
                    >
                      {category.contactCategoryName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="formComponent">
                <label>موضوع تماس : </label>
                <select className="form-control" id="subject" onChange={this.changeSubject.bind(this)}>
                  <option value="">------</option>
                  {this.state.subjectList.map((subject, index) => (
                    <option
                      selected={subject.contactSubjectId === this.state.querySubjectId ? true : false}
                      value={subject.contactSubjectId}
                    >
                      {subject.contactSubjectName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="formComponent">
                <label>جزییات تماس : </label>

                <select className="form-control" id="definition">
                  <option value="">------</option>
                  {this.state.definitionList.map((definition, index) => (
                    <option value={definition.contactDefinitionId}>{definition.contactDefinitionName}</option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label>وضعیت : </label>

                <select className="form-control" id="statusId">
                  {this.state.statusList.map((status, index) => (
                    <option value={status.contactStatusId}>{status.contactStatusName}</option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label>اولویت : </label>

                <select className="form-control" id="priority">
                  <option value="">------</option>
                  {this.state.priorityList.map((priority, index) => (
                    <option
                      selected={priority.contactPriorityId === this.state.queryPriorityId ? true : false}
                      value={priority.contactPriorityId}
                    >
                      {priority.contactPriorityName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label className="hiddenLabel">sdfdsf</label>

                <span onClick={this.openCodeForm.bind(this)} className="searchCRM">
                  جست و جوی مشتری
                </span>
              </div>
              <div className="formComponent">
                <label className="hiddenLabel">sdfdsf</label>
                <span onClick={this.openFactorForm.bind(this)} className="searchCRM">
                  جست و جوی فاکتور
                </span>
              </div>
            </div>
          </div>

          <form className="basketFilterComponent factorForm" onSubmit={this.submit.bind(this)}>
            <form className="showFactor" style={this.state.showFactor ? {display: 'block'} : {display: 'none'}}>
              <p className="title">اطلاعات فاکتور</p>
              <table className="baseTable">
                <tbody>
                  <tr>
                    <td>شماره فاکتور</td>
                    <td>شناسه فاکتور</td>
                    <td>تاریخ ثبت</td>
                    <td>تاریخ تحویل</td>
                  </tr>
                  <tr>
                    <td>{this.state.invoiceNum}</td>
                    <td>{this.state.invoiceId}</td>
                    <td>
                      {this.state.registerDate == ''
                        ? '-'
                        : jMoment(this.state.registerDate).format('jYYYY/jMM/jDD HH:mm')}
                    </td>
                    <td>
                      {this.state.deliDate == '' ? '-' : jMoment(this.state.deliDate).format('jYYYY/jMM/jDD HH:mm')}
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
            <p className="title">اطلاعات مشتری</p>
            <div className="filterInputs filterCrm">
              <div className="formComponent">
                <label>نام : </label>
                <input
                  type="text"
                  name="selectedCustomerName"
                  onChange={this.changeField.bind(this)}
                  disabled={this.state.readOnlyField}
                  value={this.state.selectedCustomerName}
                  className="form-control"
                  id="firstName"
                />
              </div>
              <div className="formComponent">
                <label>نام خانوادگی : </label>
                <input
                  type="text"
                  name="selectedCustomerLastName"
                  onChange={this.changeField.bind(this)}
                  disabled={this.state.readOnlyField}
                  value={this.state.selectedCustomerLastName}
                  className="form-control"
                  id="lastName"
                />
              </div>
              <div className="formComponent selectedCustomerMobile">
                <label>موبایل : </label>
                <input
                  type="text"
                  id="selectedCustomerMobile"
                  name="selectedCustomerMobile"
                  onChange={this.changeField.bind(this)}
                  disabled={this.state.readOnlyField}
                  value={this.state.selectedCustomerMobile}
                  className="form-control"
                  id="mobile"
                />
              </div>

              <div className="formComponent">
                <label>جنسیت : </label>
                <select className="form-control" id="gender">
                  <option value="">----</option>
                  <option value={1}>مرد</option>
                  <option value={0}>زن</option>
                </select>
              </div>

              <div className="formComponent">
                <label>کد مشتری : </label>
                <input
                  type="text"
                  className="form-control"
                  value={this.state.selectedCode}
                  name="code"
                  disabled={true}
                />
              </div>

              <div className="formComponent">
                <label className="hiddenLabel">332</label>
                <span onClick={() => this.newCustomer()} className="searchCustommer">
                  پاک کردن اطلاعات
                </span>
              </div>
              {this.state.selectedCode !== '' ? (
                <div className="formComponent">
                  <label className="hiddenLabel">332</label>
                  <span>
                    <Link
                      className="searchCustommer"
                      target="_blank"
                      to={{
                        pathname: '/baskets',
                        search: `?invoiceId=${''}&userCode=${this.state.selectedCode}`
                      }}
                    >
                      سوابق مشتری
                    </Link>
                  </span>
                </div>
              ) : (
                ''
              )}

              {this.state.selectedCode !== '' ? (
                <div className="formComponent">
                  <label className="hiddenLabel">332</label>
                  <span>
                    <Link
                      className="searchCustommer"
                      target="_blank"
                      to={{
                        pathname: '/report/user/transaction',
                        search: `?userCode=${this.state.selectedCode}`
                      }}
                    >
                      تراکنش های مشتری
                    </Link>
                  </span>
                </div>
              ) : (
                ''
              )}

              {this.state.selectedCode !== '' ? (
                <div className="formComponent">
                  <label className="hiddenLabel">332</label>
                  <span
                    onClick={() => this.openSmsModalToCustomer({customerCode: this.state.selectedCode})}
                    className="searchCustommer"
                  >
                    ارسال پیام به مشتری
                  </span>
                </div>
              ) : (
                ''
              )}

              {this.state.selectedCode !== '' ? (
                <div className="formComponent">
                  <label className="hiddenLabel">332</label>
                  <span
                    onClick={() =>
                      this.callToCustomer(
                        this.state.selectedCustomerMobile,
                        this.state.selectedCustomerName + '  ' + this.state.selectedCustomerLastName
                      )
                    }
                    className="searchCustommer"
                  >
                    تماس با مشتری
                  </span>
                </div>
              ) : (
                ''
              )}

              {this.state.showFactor === true ? (
                <div className="formComponent">
                  <label className="hiddenLabel">332</label>
                  <span
                    onClick={() => this.openSmsModalToRecipient({invoiceId: this.state.invoiceId})}
                    className="searchCustommer"
                  >
                    ارسال پیام به تحویل گیرنده
                  </span>
                </div>
              ) : (
                ''
              )}
            </div>

            <div className="crmMessageWrapp">
              <div className="formComponent">
                <label>دیدگاه : </label>
                <textarea className="form-control" id="comment" />
              </div>
              <div className="formComponent">
                <label>پاسخ : </label>
                <textarea className="form-control" id="response" />
              </div>
              <div className="formComponent">
                <label>اقدام : </label>
                <textarea className="form-control" id="action" />
              </div>
            </div>

            <div className="formComponent" style={{textAlign: 'right'}}>
              <span className="searchCustommer sendComment" onClick={this.addComment.bind(this)}>
                ثبت نظر
              </span>
            </div>
          </form>

          <Modal isOpen={this.state.smsModal} toggle={() => ''} size="md">
            <ModalHeader>{this.state.titleSms}</ModalHeader>

            <ModalBody>
              <div className="formComponent">
                <label>پیام</label>
                <textarea className="form-control" id="contents" />
              </div>
            </ModalBody>

            <ModalFooter>
              <button className="confirmBtnModal" onClick={() => this.sendSmsToCustomer()}>
                ارسال
              </button>

              <button className="cancelBtnModal" onClick={() => this.setState({smsModal: false})}>
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.searchByCustomerCode} toggle={this.toggleByCode} size="lg">
            <ModalHeader toggle={this.toggleByCode}>جست و جوی مشتری</ModalHeader>

            <ModalBody>
              <div className="modalForm searchProduct">
                <figure>
                  <label>کد مشتری : </label>
                  <input
                    type="text"
                    defaultValue={this.state.customerCode ? this.state.customerCode : ''}
                    className="form-control"
                    id="CustomerCode"
                  />
                </figure>
                <figure>
                  <label>موبایل : </label>
                  <input type="text" className="form-control" id="CustomerMobile" />
                </figure>
                <figure>
                  <label>نام : </label>
                  <input type="text" className="form-control" id="CustomerFirstName" />
                </figure>
                <figure>
                  <label>نام خانوادگی : </label>
                  <input type="text" className="form-control" id="CustomerLastName" />
                </figure>
                <figure>
                  <label>کد ملی : </label>
                  <input type="text" className="form-control" id="nationalId" />
                </figure>
                <figure>
                  <label className="hiddenLabel">332</label>
                  <span onClick={this.searchByCode.bind(this)} className="searchCustommer">
                    جست و جو
                  </span>
                </figure>
              </div>
              <div style={this.state.showTable ? {display: 'block'} : {display: 'none'}}>
                <table className="baseTable">
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>#</td>
                    <td>نام</td>
                    <td>نام خانوادگی</td>
                    <td>کد مشتری</td>
                    <td>موبایل</td>
                    <td>کد ملی</td>
                  </tr>
                  {this.state.partSearchedCustomer.map((customer, index) => (
                    <tr onDoubleClick={() => this.double((pageNumber - 1) * 10 + index + 1)}>
                      <td>{(pageNumber - 1) * 10 + index + 1}</td>
                      <td>
                        <button
                          onClick={() => this.selectFromCode((pageNumber - 1) * 10 + index + 1)}
                          className="btn btn-sm"
                          style={{color: '#000', fontWeight: '600'}}
                        >
                          انتخاب
                        </button>
                      </td>
                      <td>{customer.firstName}</td>
                      <td>{customer.lastName}</td>
                      <td>{customer.code}</td>
                      <td>{customer.phoneNumber}</td>
                      <td>{customer.nationalId}</td>
                    </tr>
                  ))}
                </table>
                <div className="paginationWrapp">
                  <Pagination
                    current={this.state.current}
                    onChange={this.onChangePage.bind(this)}
                    total={this.state.lengthSearchByCode}
                  />
                </div>
              </div>
            </ModalBody>

            <ModalFooter>
              <button className="cancelBtnModal" onClick={this.cancelByCode}>
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.searchByInvoiceNumber} toggle={this.toggleByInvoiceNum} size="lg">
            <ModalHeader toggle={this.toggleByInvoiceNum}>جست و جوی فاکتور</ModalHeader>

            <ModalBody>
              <Loader show={this.state.loading} />
              <div className="modalForm searchProduct">
                <figure>
                  <label>شناسه فاکتور : </label>
                  <input type="text" className="form-control" id="invoiceId" />
                </figure>
                <figure>
                  <label>شماره فاکتور : </label>
                  <input type="text" className="form-control" id="invoiceNum" />
                </figure>

                <figure>
                  <label>کد مشتری : </label>
                  <input
                    type="text"
                    defaultValue={this.state.customerCode ? this.state.customerCode : ''}
                    className="form-control"
                    id="customerCodeByInvoice"
                  />
                </figure>

                <figure>
                  <label>تاریخ سفارش از : </label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      labelFunc={(orderDate) => (orderDate == null ? '' : orderDate.format('jYYYY/jMM/jDD'))}
                      onChange={this.handleOrderDate}
                      TextFieldComponent={this.orderDateEl}
                      id="registerDate"
                      name="registerDate"
                      value={orderDate}
                      readOnly
                    />
                  </MuiPickersUtilsProvider>
                </figure>

                <figure>
                  <label>تاریخ سفارش تا : </label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      labelFunc={(orderDateTo) => (orderDateTo == null ? '' : orderDateTo.format('jYYYY/jMM/jDD'))}
                      onChange={this.handleOrderDateTo}
                      TextFieldComponent={this.orderDateElTo}
                      id="registerDateTo"
                      name="registerDateTo"
                      value={orderDateTo}
                      readOnly
                    />
                  </MuiPickersUtilsProvider>
                </figure>
                <figure>
                  <label>تاریخ تحویل از : </label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      labelFunc={(deliveryDate) => (deliveryDate == null ? '' : deliveryDate.format('jYYYY/jMM/jDD'))}
                      onChange={this.handleDeliveryDate}
                      TextFieldComponent={this.deliveryDateEl}
                      id="deliveryDate"
                      name="deliveryDate"
                      value={deliveryDate}
                      readOnly
                    />
                  </MuiPickersUtilsProvider>
                </figure>

                <figure>
                  <label>تاریخ تحویل تا : </label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      labelFunc={(deliveryDateTo) =>
                        deliveryDateTo == null ? '' : deliveryDateTo.format('jYYYY/jMM/jDD')
                      }
                      onChange={this.handleDeliveryDateTo}
                      TextFieldComponent={this.deliveryDateElTo}
                      id="deliveryDateTo"
                      name="deliveryDateTo"
                      value={deliveryDateTo}
                      readOnly
                    />
                  </MuiPickersUtilsProvider>
                </figure>

                <figure>
                  <label className="hiddenLabel">332</label>
                  <span onClick={() => this.searchByInvoiceNumCustomer()} className="searchCustommer">
                    جست و جو
                  </span>
                </figure>
              </div>
              <div style={this.state.showTableByInvoice ? {display: 'block'} : {display: 'none'}}>
                <table className="baseTable">
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>#</td>
                    <td>نام</td>
                    <td>شناسه فاکتور</td>
                    <td>شماره فاکتور</td>
                    <td>کد مشتری</td>
                    <td>موبایل</td>
                    <td>تاریخ ثبت</td>
                    <td>تاریخ تحویل</td>
                    <td>جزییات فاکتور</td>
                  </tr>
                  {this.state.partSearchedCustomerByInvoice.map((customer, index) => (
                    <tr onDoubleClick={() => this.dobuleByInovice((pageNumber - 1) * 10 + index + 1)}>
                      <td>{(pageNumber - 1) * 10 + index + 1}</td>
                      <td>
                        <button
                          className="btn btn-sm"
                          style={{color: '#000', fontWeight: '600'}}
                          onClick={() => this.selectedByInvoice((pageNumber - 1) * 10 + index + 1)}
                        >
                          انتخاب
                        </button>
                      </td>
                      <td>{customer.buyerFullName}</td>
                      <td>{customer.invoiceId}</td>
                      <td>{customer.invoiceNum}</td>
                      <td>{customer.code}</td>
                      <td>{customer.phoneNumber}</td>
                      <td>{jMoment(customer.regDate).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td>
                        {customer.deliveryDate == null
                          ? '-'
                          : jMoment(customer.deliveryDate).format('jYYYY/jMM/jDD HH:mm')}
                      </td>
                      <td>
                        <button onClick={() => this.showInvoiceItems(customer.invoiceId)}>
                          <img src={require('../../image/details.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </table>
                <div className="paginationWrapp">
                  <Pagination
                    current={this.state.current}
                    onChange={this.onChangePageByInvoice.bind(this)}
                    total={this.state.length}
                  />
                </div>
              </div>
            </ModalBody>

            <ModalFooter>
              <button className="cancelBtnModal" onClick={this.cancelByInvoiceNum}>
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.modalInvoiceItem} toggle={this.invoiceItems} size="lg">
            <ModalHeader toggle={this.invoiceItems}>لیست جزییات فاکتور</ModalHeader>
            <ModalBody>
              <div>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>شناسه فاکتور</td>
                      <td>عنوان</td>
                      <td>قابل پرداخت</td>
                      <td>مبلغ بعد از تخفیف</td>
                      <td>شناسه تامین کننده</td>
                    </tr>
                    {this.state.invoiceItems.map((item, index) => (
                      <tr key={index + 'det'}>
                        <td>{index + 1}</td>
                        <td>{item.invoiceid}</td>
                        <td>{item.title}</td>
                        <td>{accounting.formatMoney(item.payableamount, '', ',')}</td>
                        <td>{accounting.formatMoney(item.afterdiscountamount, '', ',')}</td>
                        <td>{item.providerid}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="paginationWrapp">
                  <Pagination
                    defaultCurrent={this.state.pageNumberDetailInvoice}
                    total={this.state.lengthProducts}
                    onChange={this.onChangePaginationDetailsInvoice.bind(this)}
                  />
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="cancelBtnModal" onClick={this.closeDetailsItems}>
                بستن
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default AddCrm
